"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatDate;
exports.getDelta = getDelta;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function formatDate(toDate, targetFormatMask, sourceFormatMask) {
  // to prevent from returning negative duration
  var countdownMillisecond = Math.max(0, getDelta(toDate, sourceFormatMask));

  var duration = _moment["default"].duration(countdownMillisecond); //to correctly display the countdown from the most granular unit


  var countdownString = _moment["default"].utc(duration.as('milliseconds')).format(targetFormatMask);

  return [countdownMillisecond, countdownString];
}

function getDelta(toDate, sourceFormatMask) {
  if (!_moment["default"].isMoment(toDate)) {
    var convert = _moment["default"].isDate(toDate) ? (0, _moment["default"])(toDate) : (0, _moment["default"])(toDate, sourceFormatMask);
    return convert.diff((0, _moment["default"])());
  }

  return toDate.diff((0, _moment["default"])());
}